<template lang="html">
  <Modal
    :transfer="transfer"
    :title="title"
    v-model="showModal"
    :class-name="bodyBgc ? 'modal-from modal-from-bgc' : 'modal-from'"
    @on-cancel="cancel"
    @on-ok="ok"
    :width="width"
    :mask-closable="maskClosable"
  >
    <UploadQuery
      :ifForm="ifForm"
      :extendData="extendData"
      :initAttachLists="imgsData"
      :store="store"
      :rowData="rowData"
      :format="format"
      :maxSize="maxSize"
      :maxLength="maxLength"
      :multiple="multiple"
      :associationUrl="associationUrl"
      :associationParam="associationParam"
      @on-check="handleCheck"
    ></UploadQuery>
  </Modal>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import UploadQuery from './uploadQuery.vue'
import objectUtil from '../../../../static/js/objectUtil'
import { Message } from 'element-ui'

const getValue = objectUtil.getValueByPath

const props = defineProps({
  /** 弹框相关参数 */
  transfer: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '选择图片',
  },
  bodyBgc: {
    type: Boolean,
    default: true,
  },
  width: {
    type: [String, Number],
    default: '1016',
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  store: {
    type: Object,
  },
  rowData: {
    // 点击按钮拿到的行级数据
    type: [String, Array, Object],
    default: null,
  },
  /** 上传图片后保存与商品的关联性 参数 */
  associationUrl: {
    type: String,
    default: 'rest/main/goods/goods_attach/submit',
  },
  /** 上传组件需要的参数 */
  /** 获取图片列表相关参数 */
  getImgListUrl: {
    type: String,
    default: 'rest/main/goods/goods_attach/queryAdvance',
  },
  criteriaCode: {
    type: String,
    default: 'ISCC_ORDER_DISTRIBUTION_GOODS_ATTACH_QUERY',
  },
  getImgListParam: {
    type: Object,
  },
  associationParam: {
    type: Object,
  },
  format: {
    type: Array,
    default: function () {
      return ['jpg', 'jpeg', 'png', 'bmp', 'gif']
    },
  },
  maxSize: {
    type: Number,
    default: 1024,
  },
  maxLength: {
    type: [Number, String],
    default: 20,
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  ifForm: { type: Boolean, default: false },
  extendData: { type: Object },
})

// 调用接口删除items有图片数据中的图片（即删除图片列表中明细行存在的图片）后，再次点击确认按钮，这时如果选择items有图片的数据不是最后一条进行此操作，就会导致把下一条数据的图片删除
// 发现 删除图片后props.rowData发生了变化（是否与删除时抛出去的行级数据有关？？），所以这里先存一下处理
// 修改bug40187(由于新建的时候明细行是不存在id的)
const rowId = props.rowData?._ID

const emits = defineEmits(['on-cancel', 'on-ok'])

// 是否显示弹框
const showModal = ref(true)
// 存储 图品列表的数据
const imgsData = ref([])

onMounted(() => {
  if (props.getImgListUrl) getImgLists()
})

const { proxy } = getCurrentInstance()
// 获取图片列表并初始化
const getImgLists = async () => {
  if (!props.getImgListUrl) {
    return
  }
  const res = await proxy.$axios.post(props.getImgListUrl, {
    criteriaCode: props.criteriaCode,
    keyword: '',
    pageNo: 1,
    pageSize: 999,
    parameters: { ...props.getImgListParam },
    totalCount: 0,
  })

  if (res?.data?.data && res.data.code === 200) {
    const rowTemp = getValue(props.rowData, 'attach')
    imgsData.value = res.data.data.map((iv) => {
      let isChecked = false
      if (rowTemp) {
        for (let j = 0; j < rowTemp.length; j++) {
          if (getValue(iv.attach, 'id') === getValue(rowTemp[j], 'id')) {
            isChecked = true
          }
        }
      }

      return {
        ...iv,
        isChecked,
        isShow: true,
      }
    })
  }
}
const handleCheck = (uploadList) => {
  imgsData.value = uploadList
}
const ok = () => {
  const temp = []

  if (imgsData.value.length > 0) {
    for (let i = 0; i < imgsData.value.length; i++) {
      if (imgsData.value[i].isChecked) {
        temp.push(getValue(imgsData.value[i], 'attach'))
      }
    }
  }
  Message.success('成功/(≥ω≤)/')
  emits('on-ok', {
    temp,
    id: rowId,
  })
}

const cancel = () => {
  emits('on-cancel')
}
</script>
